import _ from "lodash";

export default async (url, iOptions) => {
  const {
    shouldRedirect = true,
    shouldNotify = false,
    getBody: iGetBody = null,
    success = null,
    body = null,
    ssr = true,
    lazy = false,
    watch: watchers = [],
    ...options
  } = iOptions || {};

  const version = ref(0);

  const headers = useRequestHeaders(["cookie", "host"]);

  const { Notification } = useNotification();

  const pending = ref(true);
  let data = ref({});
  const error = ref(null);

  const getBody = () => {
    if (_.isFunction(iGetBody)) {
      return iGetBody();
    }
    return body;
  };

  const handleRes = async () => {
    if (error && error.value) {
      console.error({ fetchError: error.value });
    }
    if (shouldNotify && data.value && data.value.message) {
      Notification.warning({
        title: data.value.message,
      });
    }
    if (shouldRedirect && data.value && data.value.message === "请先登录") {
      if (process.client) {
        window.location.href = "/auth/login";
      }
      return;
    }
    if (_.isFunction(success)) {
      try {
        await success(data);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const getFetchOptions = () => {
    return {
      method: "post",
      body: getBody(),
      ...(options || {}),
      headers,
    };
  };

  const refresh = async () => {
    pending.value = true;
    const iVersion = (version.value += 1);
    let ret;
    try {
      const res = await $fetch.raw(url, getFetchOptions());
      ret = res._data;
      if (iVersion === version.value) {
        data.value = ret;
      }
    } catch (e) {
      error.value = e;
    }
    if (iVersion === version.value) {
      pending.value = false;
      await handleRes();
    }
    return ret;
  };

  if (!lazy) {
    if (ssr) {
      try {
        const { data: res } = await useFetch(url, getFetchOptions());
        data = res;
        pending.value = false;
        await handleRes();
      } catch (e) {
        error.value = e;
      }
    } else {
      if (!import.meta.server) {
        await refresh();
      }
    }
  }

  tryOnMounted(() => {
    if (lazy) {
      refresh();
    }
  });

  watch(watchers, () => {
    refresh();
  });

  return {
    data,
    pending,
    refresh,
  };
};
